import * as React from "react";
import PaginatedEntityTable from "components/common/PaginatedEntityTable";
import QueryHelper from "components/common/QueryHelper";
import usePluggableEntityTableElements from "hooks/usePluggableEntityTableElements";
import { Col } from "common/components";
import { useFetchEventProcedures } from "security-app/hooks/useEventProceduresAPI";
import { CurrentUserStore } from "stores/users/CurrentUserStore";
import { useColumnRenderers } from "./column-renderers";
import { useListElements, useDeserializeEventProcedures, entityActionRender } from "./constants";
import EventProcedureTabs from "../EventProcedureTabs";
function EventProcedureList() {
  const { columnRenderers } = useColumnRenderers();
  const listElements = useListElements();
  const deserializeEventProcedures = useDeserializeEventProcedures();
  const { searchEventProcedures, eventProceduresEntitiesKeyFn } = useFetchEventProcedures(deserializeEventProcedures);
  const { pluggableExpandedSections } = usePluggableEntityTableElements(
    null,
    "event_procedure"
  );
  const { pluggableAttributes } = usePluggableEntityTableElements(null, "event_procedure");
  const fetchEntities = (options) => {
    CurrentUserStore.update(CurrentUserStore.getInitialState().currentUser.username);
    return searchEventProcedures(options);
  };
  return /* @__PURE__ */ React.createElement(Col, { $align: "center" }, /* @__PURE__ */ React.createElement(
    PaginatedEntityTable,
    {
      humanName: "Event Procedures",
      additionalAttributes: pluggableAttributes.attributes,
      queryHelpComponent: /* @__PURE__ */ React.createElement(QueryHelper, { entityName: "Event Procedure" }),
      tableLayout: listElements.defaultLayout,
      fetchEntities,
      keyFn: eventProceduresEntitiesKeyFn,
      entityActions: entityActionRender,
      entityAttributesAreCamelCase: false,
      columnRenderers,
      topRightCol: /* @__PURE__ */ React.createElement(EventProcedureTabs, { viewType: "procedures" }),
      expandedSectionRenderers: pluggableExpandedSections
    }
  ));
}
export default EventProcedureList;
